export const timeline = [
  {
    title: "6 November 2022",
    cardTitle: "Lomba",
    cardSubtitle:
      "Brawijaya Entrepreneurship in Advanced Competition (BRAVO) is a competition that focuses on finding business innovations that are able to adapt in the current era and have good business sustainability.",
    linkTo: "",
  },
  {
    title: "7-8 November 2022",
    cardTitle: "Seminar",
    cardSubtitle:
      "“Solutive and Innovative Young Entrepreneurs in Society 5.0” is a seminar that focuses on the concept of Society 5.0, business activities carried out using artificial intelligence to help humans create solutions and innovations to improve business performance.",
    linkTo: "",
  },
  {
    title: "7-8 November 2022",
    cardTitle: "Expo",
    cardSubtitle:
      "“Master the Era of Globalization with Innovative Business” is an expo that is engaged in entrepreneurship, this activity is carried out because increasing global competition makes the millennial generation have to make effort to develop the economy as a whole to improve economic progress in Indonesia.",
    linkTo: "",
  },
];

export const faq = [
  {
    title: "Apa si itu BEF?",
    content:
      "Brawijaya Entrepreneur Festival atau yang biasa dikenal BEF merupakan acara kewirausahaan tahunan yang diadakan Mahasiswa Wirausaha Universitas Brawijaya. Tujuannya untuk memberikan pengetahuan dan pengalaman dalam berwirausaha dan berbisnis.",
  },
  {
    title: "Kenapa perlu ikut rangkaian BEF?",
    content:
      "Karena rangkaian acara BEF ini tanpa di pungut biaya dan terbuka untuk umum dengan pemateri yang high quality dan acara yang bermanfaat. Kalian bisa bayangin sendiri gimana serunya ketika kalian ikut BEF nanti !",
  },
  {
    title: "Siapa aja yang boleh ikut acara BEF?",
    content:
      "BEF boleh diikuti oleh semua orang (umum) ya Beftie. Jadi kalian bisa ajak siapapun buat ikutan acara BEF . ",
  },
  {
    title: "Dimana acara BEF akan dilaksanakan?",
    content:
      "BEF akan dilaksanakan secara offline di Universitas Brawijaya yaa",
  },
  {
    title: "Kapan acara BEF akan dilaksanakan?",
    content:
      "Tahun ini BEF diadakan secara offline lohh, tpi buat temen-temen seluruh indonesia dapat juga menyaksikan rangkaian acara BEF secara online lohh. dijamin pasti bakalan seru bangett !! ",
  },
  {
    title: "BEF dilakukan secara offline atau online?",
    content: "BEF akan dilaksanakan tanggal 7 dan 8 November 2022 ya Beftie",
  },
  {
    title: "Syarat mengikuti BEF?",
    content: "Syarat nya mudah banget yaitu follow instagram @bef2022_",
  },
  {
    title: "Topik yang diangkat dalam seminar BEF?",
    content:
      'Tahun ini, BEF mengangkat tema "Creating Your Entrepreneur By Developing Innovation and Sustainability in Business"',
  },
  {
    title: "Apa si itu BEF?",
    content:
      "Brawijaya Entrepreneur Festival atau yang biasa dikenal BEF merupakan acara kewirausahaan tahunan yang diadakan Mahasiswa Wirausaha Universitas Brawijaya. Tujuannya untuk memberikan pengetahuan dan pengalaman dalam berwirausaha dan berbisnis.",
  },
];